import { render, staticRenderFns } from "./CssImport.vue?vue&type=template&id=66a47d7c&scoped=true&"
import script from "./CssImport.vue?vue&type=script&lang=js&"
export * from "./CssImport.vue?vue&type=script&lang=js&"
import style0 from "./CssImport.vue?vue&type=style&index=0&id=66a47d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a47d7c",
  null
  
)

export default component.exports